// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__1TyLs","imageUploader":"EGiftCard_imageUploader__2j2SY"};